<template>
    <form v-show="isInputFormActive" method="POST">
        <div class="mx-auto">
            <h5>
                <i class="step-icon feather icon-home"></i>
                Vehicle Information
            </h5>
            <div class="row mx-auto">
                <div class="col-md-3">
                    <div class="form-group">
                        <label for="vin-number">
                            What is the Vehicles VIN Number?
                        </label>
                        <input v-model="vinNumber" type="text" class="form-control required" id="vin-number" name="vin-number">
                    </div>
                </div>
            </div>
            <div class="row mx-auto">
                <div class="col-md-4">
                    <div class="form-group">
                        <label for="finance-company">
                            What is the name the company that financed the Vehicle?
                        </label>
                        <input v-model="financeCompany" type="text" class="form-control required" id="finance-company" name="finance-company">
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="form-group">
                        <label for="purchase-date">
                            Around what date was the vehicle purchased date?
                        </label>
                        <input v-model="purchaseDate" type="date" class="form-control required" id="purchase-date" name="purchase-date">
                    </div>
                </div>
            </div>
            <div class="row mx-auto">
                <div class="col-md-4">
                    <div class="form-group">
                        <label for="purchase-state">
                            What state was the vehicle purchased in?
                        </label>
                        <Select2
                            id="purchase-state"
                            name="purchase-state"
                            v-model="purchaseState"
                            :options="stateStore.select2State()"
                        />
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label for="repo-state">
                            What state was the vehicle repossessed in?
                        </label>
                        <Select2
                            id="repo-state"
                            name="repo-state"
                            v-model="repoState"
                            :options="stateStore.select2State()"
                        />
                    </div>
                </div>
            </div>
            <div class="row mx-auto">
                <div class="col-md-4">
                    <div class="form-group">
                        <label for="resell-company">
                            What is the Company or Auction the re-sold the Vehicle?
                        </label>
                        <input v-model="resellCompany" type="text" class="form-control required" id="resell-company" name="resell-company">
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="form-group">
                        <label for="resell-date">
                            Around what date was the Vehicle re-sold?
                        </label>
                        <input v-model="resellDate" type="date" class="form-control" id="resell-date" name="resell-date">
                    </div>
                </div>
            </div>
            <hr>
        </div>
        <h6>
            <i class="step-icon feather icon-briefcase"></i>
            Collection Agency Information
        </h6>
        <div class="row mx-auto">
            <div class="col-md-3">
                <div class="form-group">
                    <label for="collection-agency">
                        Collection Agency Name
                    </label>
                    <input
                        v-model="agency.name"
                        type="text"
                        class="form-control required"
                        id="collection-agency"
                        name="collection-agency"
                        :class="{'is-invalid' : agency.error }"
                    >
                    <span v-if="agency.error" class="invalid-feedback" role="alert">
                        <strong>Field is Required</strong>
                    </span>
                </div>
            </div>
        </div>
        <div class="row mx-auto">
            <div class="col-md-3">
                <div class="form-group">
                    <label for="collection-address">
                        Address
                    </label>
                    <input v-model="agency.address" type="location" class="form-control required" id="collection-address" name="collection-address">
                </div>
            </div>

            <div class="col-md-2">
                <div class="form-group">
                    <label for="collection-city">
                        City
                    </label>
                    <input v-model="agency.city" type="text" class="form-control required" id="collection-city" name="collection-city">
                </div>
            </div>
            <div class="col-md-2">
                <div class="form-group">
                    <label for="collection-state">
                        State
                    </label>
                    <Select2
                        id="collection-state"
                        name="collection-state"
                        v-model="agency.state"
                        :options="stateStore.select2State()"
                    />
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label for="collection-zipcode">
                        Zipcode
                    </label>
                    <input v-model="agency.zipcode" type="text" class="form-control" id="collection-zipcode" name="collection-zipcode">
                </div>
            </div>
        </div>
        <hr>
        <h6>
            <i class="step-icon feather icon-briefcase"></i>
            Original Creditor Information
        </h6>
        <div class="row mx-auto">
            <div class="col-md-3">
                <div class="form-group">
                    <label for="original-creditor">
                        Original Creditor Name
                    </label>
                    <input v-model="creditor.name" type="text" class="form-control required" id="original-creditor" name="original-creditor" >
                </div>
            </div>
        </div>
        <div class="row mx-auto">
            <div class="col-md-3">
                <div class="form-group">
                    <label for="original-creditor-address">
                        Address
                    </label>
                    <input v-model="creditor.address" type="location" class="form-control required" id="original-creditor-address" name="original-creditor-address">
                </div>
            </div>

            <div class="col-md-2">
                <div class="form-group">
                    <label for="original-creditor-city">
                        City
                    </label>
                    <input v-model="creditor.city" type="text" class="form-control required" id="original-creditor-city" name="original-creditor-city">
                </div>
            </div>
            <div class="col-md-2">
                <div class="form-group">
                    <label for="original-creditor-state">
                        State
                    </label>
                    <Select2
                        id="original-creditor-state"
                        name="original-creditor-state"
                        v-model="creditor.state"
                        :options="stateStore.select2State()"
                    />
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label for="original-creditor-zipcode">
                        Zipcode
                    </label>
                    <input v-model="creditor.zipcode" type="text" class="form-control" id="original-creditor-zipcode" name="original-creditor-zipcode">
                </div>
            </div>
        </div>
        <hr>
        <h6>
            <i class="step-icon feather icon-briefcase"></i>
            Car Dealership Information
        </h6>
        <div class="row mx-auto">
            <div class="col-md-3">
                <div class="form-group">
                    <label for="car-dealer">
                        Car Dealer Name
                    </label>
                    <input v-model="dealer.name" type="text" class="form-control required" id="car-dealer" name="car-dealer">
                </div>
            </div>
        </div>

        <div class="row mx-auto">
            <div class="col-md-3">
                <div class="form-group">
                    <label for="car-dealer-address">
                        Address
                    </label>
                    <input v-model="dealer.address" type="location" class="form-control required" id="car-dealer-address" name="car-dealer-address">
                </div>
            </div>

            <div class="col-md-2">
                <div class="form-group">
                    <label for="car-dealer-city">
                        City
                    </label>
                    <input v-model="dealer.city" type="text" class="form-control required" id="car-dealer-city" name="car-dealer-city">
                </div>
            </div>
            <div class="col-md-2">
                <div class="form-group">
                    <label for="car-dealer-state">
                        State
                    </label>
                    <Select2
                        id="car-dealer-state"
                        name="car-dealer-state"
                        v-model="dealer.state"
                        :options="stateStore.select2State()"
                    />
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label for="car-dealer-zipcode">
                        Zipcode
                    </label>
                    <input v-model="dealer.zipcode" type="text" class="form-control" id="car-dealer-zipcode" name="car-dealer-zipcode">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <router-link
                    :to="{ name: 'disputes-report'}"
                    class="btn btn-primary btn-submit mr-50" target="_self"
                    v-if="userStore.user.isDiy"
                >
                Back
                </router-link>
                <a :href="$router.resolve({ name: 'disputes-report'}).href" class="btn btn-primary btn-submit mr-50" v-else>{{ localizationStore.translate("letter.create.back.button.text") }}</a>
                <button @click="submitForm" type="button" class="btn btn-outline-primary btn-submit">Submit</button>
            </div>
        </div>
    </form>
    <section v-show="!isInputFormActive">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header p-0 mb-50 mx-auto">
                        <a class="go-back" @click="goBack" >{{ localizationStore.translate("letter.create.back.button.text") }}</a>
                    </div>
                    <div class="card-content">
                        <div class="card-body">
                            <form :action="routes.createLetterRoute" method="post" enctype="multipart/form-data" class="row">
                                <input type="hidden" name="_token" :value="csrf">
                                <input type="text" class="form-control" id="creditbureau" name="creditbureau" :value="agency.name" hidden>
                                <div class="col-md-6 pl-md-0 pr-md-3">
                                    <div id="editor">
                                    </div>
                                    <div class="d-flex justify-content-center my-1">
                                        <button class="btn btn-sm-block btn-primary" type="submit" name="editorType" value="1">
                                            {{ localizationStore.translate("letter.left.submit.button.text") }}
                                        </button>
                                    </div>
                                </div>
                                <div class="col-md-6 pl-md-3 pr-md-0 mt-3 mt-md-0">
                                    <div class="arrow-btn">
                                        <button
                                            class="btn btn-outline-primary px-50"
                                            @click="$refs.spinner.spinLetter()"
                                            type="button"
                                        >
                                            {{ localizationStore.translate("spin.letter.button.text") }}
                                            <i data-feather="arrow-right"></i>
                                        </button>
                                    </div>
                                    <div id="editor-right">
                                    </div>
                                    <div class="d-flex justify-content-center my-1">
                                        <button class="btn btn-sm-block btn-primary" type="submit" name="editorType" value="2">
                                            {{ localizationStore.translate("letter.right.submit.button.text") }}
                                        </button>
                                    </div>
                                </div>
                                <spinner ref="spinner" :user-info='userInfo' :editor-ref='editorRef' />
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div ref="editorRef" hidden>
            <p style="padding: 15px 50px">
                {{ userInfo.firstname }}
                {{ userInfo.lastname }}
                <br />
                {{ userInfo.address }}
                <br />
                {{ userInfo.city }}
                {{ userInfo.state }}
                {{ userInfo.zipcode }}
            </p>
            <p style="padding: 15px 50px">
                {{ agency.name }}
                <br />
                {{ agency.address }}
                <br />
                {{ agency.city }}
                {{ agency.state }}
                {{ agency.zipcode }}
            </p>
            <p style="padding: 15px 50px">
                {{ creditor.name }}
                <br />
                {{ creditor.address }}
                <br />
                {{ creditor.city }}
                {{ creditor.state }}
                {{ creditor.zipcode }}
            </p>

            <p style="padding: 15px 50px">
                {{ dealer.name }}
                <br />
                {{ dealer.address }}
                <br />
                {{ dealer.city }}
                {{ dealer.state }}
                {{ dealer.zipcode }}
            </p>

            <p style="padding: 15px 50px">{{ date }}</p>
            <p style="padding: 15px 50px">RE: VIN #: {{ vinNumber }}</p>
            <p style="padding: 15px 50px">To Whom It May Concern,</p>
            <p style="padding: 15px 50px">
                This letter is a formal statement notifying the above parties that the accounts under
                VIN #: {{ vinNumber }} are disputed.</p>
            <p style="padding: 15px 50px">
                The vehicle in question was purchased on or about
                {{ purchaseDate }}, financed by
                {{ financeCompany }}, repossessed in the state of
                {{ repoState }}, and sold by
                {{ resellCompany }} on or about
                {{ repoState }}.
            </p>
            <p class="letter-content" style="padding: 15px 50px">
                Under the laws of {{ purchaseState }} and UCC § 9.506 as well as State RISA and MVISA statutes, a deficiency can not be claimed unless all of the required notices were properly and timely given, and all of the allowable redemption and cure time limits were adhered to.
            </p>
            <p class="letter-content" style="padding: 15px 50px">
                I demand proof that the repossession of the subject vehicle was legal in accordance with the following UCC:</p>
            <p style="padding: 15px 50px">§ 9-506. EFFECT OF ERRORS OR OMISSIONS.</p>
            <p style="padding: 15px 50px">§ 9-611. NOTIFICATION BEFORE DISPOSITION OF COLLATERAL.</p>
            <p style="padding: 15px 50px">§ 9-612. TIMELINESS OF NOTIFICATION BEFORE DISPOSITION OF COLLATERAL.</p>
            <p style="padding: 15px 50px">§ 9-613. CONTENTS AND FORM OF NOTIFICATION BEFORE DISPOSITION OF COLLATERAL.</p>
            <p class="letter-content" style="padding: 15px 50px">
                You are required to provide me with copies of the legal notices and proof of the commercially reasonable manner of the notification and resale of the subject vehicle.
            </p>
            <p class="letter-content" style="padding: 15px 50px">
                If no such proof is provided within 15 days from receipt of this certified mail notice, the alleged claim of a deficiency will be considered null and void, and any continued collection activities, or continued reporting of this invalid claim on my credit reports will be considered a violation of the FDCPA and FCRA.
            </p>
            <p class="letter-content" style="padding: 15px 50px">
                In addition, if you singularly or severally fail to comply with the above requests, I reserve the right to seek damages against all parties, under all available State and Federal statutes and including but not limited to UCC § 9-625 remedies.
            </p>
            <p class="letter-content" style="padding: 15px 50px">
                Furthermore, you are hereby notified that at no point in time and under no circumstances is your company; an employee of your company; a representative for your company or affiliates are to contact me or any family members by any means other than the US mail system.
            </p>

            <p style="padding: 15px 50px">
                {{ userInfo.firstname }}
                {{ userInfo.lastname }}
                <br />

                <p style="padding: 15px 50px">
                    SSN: {{ userInfo.ssn }}
                </p>
                {{ userInfo.address }}
                <br />
                {{ userInfo.city }}
                {{ userInfo.state }}
                {{ userInfo.zipcode }}
            </p>
            <p style="padding: 15px 50px">
                Cc: Consumer Financial Protection Bureau
                <br />Cc: Attorney General's Office
                <br />Cc: Better Business Bureau
            </p>
        </div>
    </section>
</template>
<script>
  import { reactive, computed, ref } from 'vue'
  import { useStateStore } from '../../stores/StateStore.js'
  import Select2 from 'vue3-select2-component';
  import { useLocalizationStore } from '../../stores/LocalizationStore.js'
  import { useUserStore } from '../../stores/UserStore.js'
  export default {
    props: {
        csrf: {
            type: String
        },
        userInfo: {
            type: [Array, Object]
        },
    },
    components: {
        Select2
    },
    setup(props) {
        return {
            editorRef: ref(null),
            isInputFormActive: ref(true),
            vinNumber: ref(null),
            financeCompany: ref(null),
            purchaseDate: ref(null),
            purchaseState: ref(null),
            repoState: ref(null),
            resellCompany: ref(null),
            resellDate: ref(null),
            date: ref(null),
            agency: reactive({
                name: null,
                address: null,
                city: null,
                state: null,
                zipcode: null,
                error: null
            }),
            creditor: reactive({
                name: null,
                address: null,
                city: null,
                state: null,
                zipcode: null,
            }),
            dealer: reactive({
                name: null,
                address: null,
                city: null,
                state: null,
                zipcode: null,
            }),
            stateStore: useStateStore(),
            localizationStore: useLocalizationStore(),
            userStore: useUserStore()
        };
    },
    created() {
    },
    mounted() {
        axios.get(this.routes.currentDate).then(response => (this.date = response.data))
    },
    computed: {
    },
    methods: {
        submitForm: function () {
            if (this.validate()) {
                setTimeout(() => {
                    tinymce.get('editor').setContent(this.editorRef.innerHTML);
                    this.isInputFormActive = !this.isInputFormActive;
                }, "100");
            }
        },
        goBack: function () {
            this.isInputFormActive = !this.isInputFormActive;
        },
        validate: function () {
            if (this.agency.name == null || this.agency.name == "null") {
                this.agency.error = true;
            }
            else {
                this.agency.error = false;
            }
            return !this.agency.error;
        },
    }
  };
</script>
<style type="text/css">
    .select2-container--default .select2-selection--single .select2-selection__arrow b {
        border-width: 0;
        height: inherit;
        left: 10%;
    }
</style>
